// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearchInterestTags-cls1___45dd1f46a605ebfa434{/*!*/}.ResearchInterestTags-cls2__a1b38b69eeb60d454833{padding:5px 10px;height:30px;border:1px solid #ddd;margin:5px 10px 0 0;font-size:12px;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearchInterestTags-cls1___45dd1f46a605ebfa434",
	"cls2": "ResearchInterestTags-cls2__a1b38b69eeb60d454833 ResearchInterestTags-cls1___45dd1f46a605ebfa434"
};
export default ___CSS_LOADER_EXPORT___;
